if (!customElements.get('size-chart')) {
    class SizeChart extends HTMLElement {
        constructor() {
            super();

            this.currentUnit = 'cm';

            this.attachOpener();
            this.attachUnitsToggle();
            this.convertUnits('in');
        }

        /**
         * Opens the drawer.
         */
        attachOpener() {
            const drawer = document.querySelector('.js-size-chart-drawer');
            if (drawer) drawer.remove();

            document.body.appendChild(drawer);

            const showSizeChartBtn = this.querySelector('.js-show-size-chart');
            if (showSizeChartBtn) {
                showSizeChartBtn.addEventListener('click', () => {
                    document.querySelector('.js-size-chart-drawer').open(showSizeChartBtn);
                });
            }
        }

        /**
         * Toggle Units between "cm" and "in".
         */
        convertUnits(newUnit) {
            if (this.currentUnit === newUnit) return;

            const sizeCharts = document.querySelectorAll('#sizechart');
            const currentUnitLabel = document.getElementById('currentUnitSizeChart');
            const isCM = newUnit === "cm";

            // Matches headers made up of region/country size codes, e.g.
            // "US/CA", "AU/NZ", "UK/AU/NZ", "EU/JP", "Size", etc.
            const REGION_CODE = 'us|uk|ca|au|nz|eu|jp|kr|cn|mx|size';
            const NON_MEASUREMENT_HEADER_RE = new RegExp(
                `^(${REGION_CODE})(\\s*\\/\\s*(${REGION_CODE}))*$`, 'i'
            );

            sizeCharts.forEach(function(sizeChart) {
                const headerCells = Array.from(sizeChart.querySelectorAll('thead tr:first-child th'));
                const headers = headerCells.map(th => th.textContent.trim());

                sizeChart.querySelectorAll('tbody tr').forEach(function(row) {
                    row.querySelectorAll('td').forEach(function(element, index) {
                        const headerName = headers[index + 1]; // +1 skips the rowheader "Size" th

                        const isKnownNonMeasurement = headerName
                            ? NON_MEASUREMENT_HEADER_RE.test(headerName.trim())
                            : index < 2; // fallback if headers are missing/unparseable

                        if (isKnownNonMeasurement) return;

                        const value = element.textContent.trim();

                        const range = value.split('-');
                        const allNumeric = range.every(function(part) {
                            return part.trim() !== '' && !isNaN(parseFloat(part.trim())) && isFinite(part.trim());
                        });

                        if (!allNumeric) return;

                        const convertedRange = range.map(function(num) {
                            return isCM
                                ? Math.round(parseFloat(num.trim()) * 2.54)
                                : Math.round(parseFloat(num.trim()) / 2.54);
                        });
                        element.textContent = convertedRange.join('-');
                    });
                });
            });

            currentUnitLabel.innerText = `Current is ${newUnit === "cm" ? "CM" : "INCH"}`;
            this.currentUnit = newUnit;
        }

        /**
         * Adds toggle behavior.
         */
        attachUnitsToggle() {
            document.querySelectorAll('.size-chart-toggle').forEach(toggle => {
                toggle.addEventListener('click', e => {
                    const btn = e.target.closest('.size-chart-toggle__option');
                    if (!btn) return;

                    toggle
                        .querySelectorAll('.size-chart-toggle__option')
                        .forEach(b => b.classList.remove('is-active'));

                    btn.classList.add('is-active');

                    const unit = btn.dataset.unit;
                    this.convertUnits(unit);

                });
            });
        }
    }

    customElements.define('size-chart', SizeChart);
}